import { useEffect, useState } from 'react';
import { Circles } from 'react-loading-icons';
import { getLifeBusinesses } from '../../../util/apis/LifeAPI';
import Button from '../../Button';

export default function LifeTab() {
  const [content, setContent] = useState([]);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getLifeBusinesses.get();
      setContent(data.results);
      console.log(data.results);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (content.length > 0) {
      let loadedCount = 0;
      content.forEach((item) => {
        const img = new Image();
        img.src = item.image_url || 'https://via.placeholder.com/150';
        img.onload = () => {
          loadedCount++;
          if (loadedCount === content.length) {
            setImagesLoaded(true);
          }
        };
        img.onerror = () => {
          loadedCount++;
          if (loadedCount === content.length) {
            setImagesLoaded(true);
          }
        };
      });
    }
  }, [content]);

  return (
    <>
      {imagesLoaded ? (
        <>
          <div className="grid place-items-center lg:grid-cols-4 sm:grid-cols-2 grid-cols-2 gap-y-8 gap-x-3 px-3 md:px-20 lg:px-28 sm:max-h-hidden overflow-hidden">
            {content.map((item, id) => (
              <a
                key={id}
                href={`/rate/business/${item.id}`}
                className="relative mb-10 md:w-72 lg:w-96"
              >
                <span className="absolute top-4 left-0 -rotate-45 bg-green-500 text-white px-2 py-0.5 rounded-lg text-xs">
                  Business
                </span>
                <img
                  src={item.image_url}
                  className="rounded-t-xl border-2 aspect-backdrop w-full max-w-full"
                  alt={item.name}
                />

                <div className="bg-white rounded-b-xl absolute w-full p-1 text-nowrap whitespace-nowrap text-ellipsis">
                  {item.name}
                </div>
              </a>
            ))}
          </div>
          <div className="flex justify-center py-5">
            <Button variant="button" type="button" disabled>
              More Coming Soon
            </Button>
          </div>
        </>
      ) : (
        <div className="text-5xl text-white">
          <Circles />
        </div>
      )}
    </>
  );
}
